import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../../firebase/firebaseConfig";
import Portada from "../../components/Portada/Portada";
import Filtros from "../../components/Filtros/Filtros";
import Producto from "../../components/Producto/Producto";
import { Spinner } from "react-bootstrap";
import "./Productos.css";
import Footer from "../../components/Footer/Footer.js";


const Productos = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [selectedCategory, setSelectedCategory] = useState(id || "Todos");
  const [productos, setProductos] = useState([]);
  const [loading, setLoading] = useState(true);

  const categorias = [
    "Todos",
    "Canastos Freidores",
    "Batidores y Espumaderas",
    "Brocheteria",
    "Posa Tortas",
    "Pinzas Carliteras",
    "Cajones",
    "Vaporieras",
    "Rejillas",
  ];

  useEffect(() => {
    setSelectedCategory(id || "Todos");
  }, [id]);

  useEffect(() => {
    const fetchProductos = async () => {
      setLoading(true);
      const productosRef = collection(db, "productos");
      let q = selectedCategory !== "Todos" ? query(productosRef, where("category", "==", selectedCategory)) : productosRef;

      try {
        const querySnapshot = await getDocs(q);
        setProductos(querySnapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
      } catch (error) {
        console.error("Error al obtener los productos:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchProductos();
  }, [selectedCategory]);

  const handleFilterSelect = (category) => {
    setSelectedCategory(category);
    navigate(category === "Todos" ? "/productos" : `/productos/${category}`);
  };

  if (loading) {
    return (
      <div className="loading-container">
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Cargando...</span>
        </Spinner>
      </div>
    );
  }

  return (
    <div>
      <Portada titulo="Nuestros Productos" />

      <div className="productos-container">
        <div className="categorias d-none d-lg-block">
          <Filtros categories={categorias} onFilterSelect={handleFilterSelect} />
        </div>

        <div className="productos-content">
          <h1 className="productos-titulo">{selectedCategory}</h1>
          <h2 className="productos-subtitulo">PRODUCTOS | {selectedCategory.toUpperCase()}</h2>
          <div className="productos-grid">
            {productos.map((producto) => (
              <Producto
                key={producto.id}
                id={producto.id}
                name={producto.name}
                category={producto.category}
                image={`/images/${producto.pictureUrl}`}
              />
            ))}
          </div>
        </div>
      </div>
      <Footer />
    </div>

  );
};

export default Productos;
